(() => {
  if (window.schmelzwerk3dConfirmationV2Loaded) return;
  window.schmelzwerk3dConfirmationV2Loaded = true;

  const contexts = [
    { root: '#main-cart-footer', button: '#checkout', form: 'cart' },
    { root: '#CartDrawer', button: '#CartDrawer-Checkout', form: 'CartDrawer-Form' }
  ];

  function elements(context) {
    const root = document.querySelector(context.root);
    return {
      root,
      button: root && root.querySelector(context.button),
      checkbox: root && root.querySelector('[data-confirmation-3d-checkbox]')
    };
  }

  function sync() {
    contexts.forEach((context) => {
      const { root, button, checkbox } = elements(context);
      if (!button) return;
      if (checkbox) {
        button.disabled = !checkbox.checked;
        button.dataset.confirmation3dManaged = 'true';
      } else if (button.dataset.confirmation3dManaged === 'true') {
        const drawer = root.closest('cart-drawer');
        button.disabled = root.classList.contains('is-empty') ||
          Boolean(drawer && drawer.classList.contains('is-empty'));
        delete button.dataset.confirmation3dManaged;
      }
    });
  }

  function allow(context) {
    const { root, checkbox } = elements(context);
    if (!checkbox || checkbox.checked) return true;
    const error = root.querySelector('[data-confirmation-3d-error]');
    if (error) error.hidden = false;
    checkbox.focus();
    checkbox.reportValidity();
    return false;
  }

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.matches('[data-confirmation-3d-checkbox]')) return;
    const box = event.target.closest('[data-confirmation-3d]');
    const error = box && box.querySelector('[data-confirmation-3d-error]');
    if (error) error.hidden = true;
    sync();
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const context = contexts.find((entry) =>
      event.target.closest(entry.root + ' ' + entry.button)
    );
    if (context && !allow(context)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const context = contexts.find((entry) => event.target.id === entry.form);
    if (!context) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (!allow(context)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function start() {
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
